import { render, staticRenderFns } from "./DeliveryAttempts.vue?vue&type=template&id=62d75ac6"
import script from "./DeliveryAttempts.vue?vue&type=script&lang=js"
export * from "./DeliveryAttempts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports